import { Modal } from 'react-bootstrap';

/**
 * DK : Modal informacyjny z 1 guzikiem
 * @param show Czy ma się wyświetlać 
 */
const InformationErrorModal = ({ show, setShow, title, message, isError, buttonText = 'OK', isVersionControlInfo = false, showCloseButton = false }) => {
    return (
        <>
            <Modal size='lg' show={show} onHide={() => setShow(false)} centered>
                <Modal.Header closeButton={showCloseButton}>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className={isError ? 'error-text-color' : ''} style={{ fontSize: '1.3rem', whiteSpace: 'pre-line' }}>{message}</p>
                    {isVersionControlInfo && <div className="d-flex justify-content-between align-items-center" style={{ fontSize: '16px' }}>
                        <span className='error-text-color'>{`Obecna wersja: ${localStorage.getItem('OLD_APP_VERSION')}`}</span>
                        <span className='success-text-color'>{`Nowa wersja: ${localStorage.getItem('APP_VERSION')}`}</span>
                    </div>}

                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex flex-column'>
                        <button className='btn-app-primary me-3' onClick={() => setShow(false)}>{buttonText}</button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default InformationErrorModal